export enum RewardShopActionTypes {
  GET_ALL_PRODUCTS = '@reward-shop/GET_ALL_PRODUCTS',
  GET_ONE_PRODUCT = '@reward-shop/GET_ONE_PRODUCT',
  ORDER_PRODUCT = '@reward-shop/ORDER_PRODUCT',
}
